export const WEB_API_URL = process.env.REACT_APP_WEB_API;
